import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { ArrowRight, Globe } from "lucide-react";
import API from "@/apiConfig";

// Subtle, single-strip "featured page" ribbon for the home page.
// Renders only when an admin has flagged a published page as featured.
export const HomeFeatureBanner = () => {
  const [page, setPage] = useState(null);

  useEffect(() => {
    axios.get(`${API}/pages-featured`)
      .then((r) => { if (r.data && r.data.slug) setPage(r.data); })
      .catch(() => {});
  }, []);

  if (!page) return null;

  const eyebrow = page.hero_subheading || "Featured";
  const title = page.hero_heading || page.title;

  return (
    <section className="bg-[#FDFBF7] border-y border-[#D4AF37]/25" data-testid="home-feature-banner">
      <Link
        to={`/p/${page.slug}`}
        className="group block max-w-6xl mx-auto px-5 sm:px-8 py-4"
        data-testid="home-feature-link"
      >
        <div className="flex items-center gap-4">
          {page.image_url ? (
            <img
              src={page.image_url}
              alt=""
              className="h-14 w-14 sm:h-16 sm:w-16 rounded-sm object-cover border border-[#D4AF37]/30 shadow-sm shrink-0"
            />
          ) : (
            <div className="h-14 w-14 rounded-sm bg-[#0A1A2F] flex items-center justify-center shrink-0">
              <Globe className="h-6 w-6 text-[#D4AF37]" />
            </div>
          )}

          <div className="min-w-0 flex-1">
            <p className="text-[#D4AF37] text-[11px] font-semibold tracking-[0.15em] uppercase">
              {eyebrow}
            </p>
            <p className="font-heading text-lg sm:text-xl text-[#0A1A2F] leading-tight truncate">
              {title}
            </p>
            {page.hero_meta && (
              <p className="text-xs text-slate-500 truncate hidden sm:block">{page.hero_meta}</p>
            )}
          </div>

          <span className="shrink-0 inline-flex items-center gap-1.5 text-sm font-semibold text-[#0A1A2F] border-b-2 border-transparent group-hover:border-[#D4AF37] transition-colors">
            <span className="hidden sm:inline">{page.cta_label || "Learn More"}</span>
            <ArrowRight className="h-4 w-4 group-hover:translate-x-0.5 transition-transform" />
          </span>
        </div>
      </Link>
    </section>
  );
};

export default HomeFeatureBanner;
